export enum BillingTypeEnum {
  Monthly = 'monthly',
  Yearly = 'yearly',
}
